module.exports = __webpack_public_path__ + "img/ltkasia-3x.776e07b.jpg";